import { render, staticRenderFns } from "./AudioView.vue?vue&type=template&id=8978e9f6&scoped=true"
import script from "./AudioView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AudioView.vue?vue&type=style&index=0&id=8978e9f6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8978e9f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8978e9f6')) {
      api.createRecord('8978e9f6', component.options)
    } else {
      api.reload('8978e9f6', component.options)
    }
    module.hot.accept("./AudioView.vue?vue&type=template&id=8978e9f6&scoped=true", function () {
      api.rerender('8978e9f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/content/AudioView.vue"
export default component.exports